import script from "./MainHeaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainHeaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainHeaderComponent.vue?vue&type=style&index=0&id=2c76abd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c76abd2"]])

export default __exports__